import { Region } from "@/store/types";

export function getLocalRegion(): Region {
	return {
		regionId: 0,
		regionUserId: null,
		connected: true,
		title: "Local",
		url: null,
		friendlyName: "Local",
		active: true
	};
}
